module.exports = __webpack_public_path__ + "static/media/IMG_1172.26273839.jpg";